const SYSTEM_ADMINISTRATOR_ROLE = 'system-administrator'

export const USER_PROFILE = Object.freeze({
  SYS_ADMIN: 'SysAdmin',
  DIGITAL_TEAM: 'DigitalTeam',
  REGULAR: 'Regular',
})

const PROFILE_RULES = Object.freeze([
  {
    profile: USER_PROFILE.SYS_ADMIN,
    matches: ({ roles }) => roles.includes(SYSTEM_ADMINISTRATOR_ROLE),
  },
])

export function resolveUserProfile(context = {}) {
  const normalizedContext = {
    ...context,
    roles: Array.isArray(context?.roles) ? context.roles : [],
  }

  const matchedRule = PROFILE_RULES.find(rule => rule.matches(normalizedContext))

  return matchedRule?.profile ?? USER_PROFILE.REGULAR
}
